import { render } from "./BaseCustomAlert.vue?vue&type=template&id=3e915f05"
import script from "./BaseCustomAlert.vue?vue&type=script&lang=js"
export * from "./BaseCustomAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__